import React, { useEffect, useState, useContext, useRef } from 'react';
import './DevelopmentTip.scss';
import Modal from '../Modal/Modal';
import { ReactComponent as DevTipBlock1 } from '../../../assets/images/blocks1.svg';
import { gsap } from 'gsap';
import { Context } from '../../../context';
export default function DevelopmentTip(props) {
  const context = useContext(Context);
  const [content, setContent] = useState(null);
  const [show, showModal] = useState(false);
  const clicked = useRef(false);
  const canMarkMissed = useRef(false);
  const checkDevTipsRef = useRef(context.checkDevTips);
  const devTipTargetRef = useRef({
    moduleIndex: props.mod ?? context.state.curModIndex,
    content: props.content,
  });
  const moduleIndex = props.mod ?? context.state.curModIndex;

  useEffect(() => {
    checkDevTipsRef.current = context.checkDevTips;
  }, [context.checkDevTips]);

  useEffect(() => {
    devTipTargetRef.current = {
      moduleIndex,
      content: props.content,
    };
  }, [moduleIndex, props.content]);

  useEffect(() => {
    if (moduleIndex === '' || moduleIndex === undefined) {
      return;
    }

    setContent({
      __html: context.state.allDevTips[moduleIndex][props.content - 1].content,
    });
  }, [context.state.allDevTips, moduleIndex, props.content]);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      canMarkMissed.current = true;
    }, 0);

    return () => {
      window.clearTimeout(timeoutId);

      const { moduleIndex: currentModuleIndex, content: currentContent } =
        devTipTargetRef.current;

      if (
        !canMarkMissed.current ||
        clicked.current ||
        currentModuleIndex === '' ||
        currentModuleIndex === undefined
      ) {
        return;
      }

      checkDevTipsRef.current(currentModuleIndex, currentContent, 'missed');
    };
  }, []);

  const openDevTip = () => {
    // send some logic so that the context knows that this specific devtip was clicked
    showModal(true);
  };
  const animation = () => {
    gsap.to('pulse');
  };
  return (
    <>
      <button
        className='devTip-display'
        onClick={() => {
          openDevTip();
          clicked.current = true;
          context.checkDevTips(moduleIndex, props.content, 'clicked');
        }}
      >
        <div className='word-wrapper'>
          <span>Developmental Tip</span>
          {/* <span>Tip</span> */}
        </div>
        <DevTipBlock1 className='pulse' />
      </button>
      <Modal
        show={show}
        showModal={showModal}
        portalToBody
      >
        <div className='devtip-wrap'>
          <div className='head'>
            <div className='icon'></div>
          </div>
          <div
            className='devtip-content'
            dangerouslySetInnerHTML={content}
          ></div>
        </div>
      </Modal>
    </>
  );
}
